import script from "./Touch.vue?vue&type=script&setup=true&lang=js"
export * from "./Touch.vue?vue&type=script&setup=true&lang=js"

import "./Touch.vue?vue&type=style&index=0&id=4734fe2e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4734fe2e"]])

export default __exports__